module.exports = __webpack_public_path__ + "media/images/site/step-five-460b818ebf14d373d61d844149169997.svg";